import { formsSlice } from "./slice";

export const {
    reducer: formsReducer,
} = formsSlice;